import Seo from "@/lib/seo";
import PageHero from "@/components/PageHero";
import { Reveal } from "@/components/motion/Reveal";
import { useSite } from "@/hooks/content";

export default function Privacy() {
  const { site } = useSite();

  return (
    <>
      <Seo title="Privacy Policy" description="Privacy Policy for SKY Training & Consultancy Pte Ltd." path="/privacy-policy" />
      <PageHero eyebrow="Legal" title="Privacy Policy" breadcrumb={[{ name: "Home", path: "/" }, { name: "Privacy Policy", path: "/privacy-policy" }]} />
      <section className="section-pad">
        <div className="container-sky max-w-3xl">
          <Reveal>
            <div className="space-y-6 text-sm leading-relaxed text-slate-700 sm:text-base">
              <p>This Privacy Policy explains how {site.name} ("SKY", "we", "us") handles information collected through this website. This is a placeholder policy and should be reviewed and finalised before launch.</p>
              <h2 className="font-heading text-xl font-bold text-navy">Information We Collect</h2>
              <p>When you submit an enquiry, we may collect your name, company, mobile number, email address, selected service and message. We use this information solely to respond to your enquiry.</p>
              <h2 className="font-heading text-xl font-bold text-navy">How We Use Information</h2>
              <p>Information you provide is used to respond to enquiries, provide requested services and communicate with you about your requirements.</p>
              <h2 className="font-heading text-xl font-bold text-navy">Data Protection</h2>
              <p>We take reasonable measures to protect the information you provide. We do not sell your personal information.</p>
              <h2 className="font-heading text-xl font-bold text-navy">Contact</h2>
              <p>For any privacy-related queries, contact us at {site.email} or {site.mobile}.</p>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
